import React from 'react';
import { AlertTriangle, UserX, X, Loader2 } from 'lucide-react';

const DeleteAccountModal = ({
  showDeleteConfirmation,
  setShowDeleteConfirmation,
  deleteConfirmText,
  setDeleteConfirmText,
  deleteLoading,
  handleDeleteAccount
}) => {
  if (!showDeleteConfirmation) return null;

  return (
    <div 
      className="modal-overlay" 
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          setShowDeleteConfirmation(false);
          setDeleteConfirmText('');
        }
      }}
    >
      <div className="modal modal-sm">
        {/* 헤더: 아이콘 + 타이틀 */}
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0 bg-red-100">
            <AlertTriangle className="w-6 h-6 text-red-600" />
          </div>
          <h3 className="text-xl font-semibold text-gray-900">
            계정 삭제
          </h3>
        </div>
        
        {/* 메시지 영역 */}
        <div className="space-y-4">
          <div className="bg-red-50 border border-red-200 rounded-lg p-4">
            <p className="text-sm font-medium text-red-900 mb-2">
              정말로 계정을 삭제하시겠습니까?
            </p>
            <div className="text-sm text-red-700 space-y-2">
              <p>계정 삭제 시 다음과 같은 작업이 진행됩니다:</p>
              <ul className="list-disc list-inside space-y-1 ml-2">
                <li>모든 개인정보가 익명화됩니다</li>
                <li>작성한 이력서와 포트폴리오가 삭제됩니다</li>
                <li>상담 세션 및 대화 내용이 비공개됩니다</li>
                <li>프로모션 코드 사용 내역만 보관됩니다</li>
                <li><strong>삭제된 데이터는 복구할 수 없습니다</strong></li>
              </ul>
            </div>
          </div>

          <div>
            <p className="text-sm text-gray-700 mb-2">
              계정 삭제를 확인하려면 아래에 <strong>"계정을 삭제합니다"</strong>라고 입력해주세요.
            </p>
            <input
              type="text"
              value={deleteConfirmText}
              onChange={(e) => setDeleteConfirmText(e.target.value)}
              placeholder="계정을 삭제합니다"
              className="input w-full"
              disabled={deleteLoading}
            />
          </div>

          <div className="text-sm text-gray-600 bg-gray-50 p-3 rounded-lg">
            <p className="font-medium mb-1">알아두세요:</p>
            <ul className="list-disc list-inside space-y-1 ml-2 text-gray-500">
              <li>동일한 이메일로 재가입 가능합니다</li>
              <li>기존 데이터와는 연결되지 않습니다</li>
              <li>법적 보관 의무가 있는 데이터는 익명화되어 보관됩니다</li>
            </ul>
          </div>
        </div>
        
        {/* 버튼 영역 */}
        <div className="flex gap-3 mt-8">
          <button
            onClick={() => {
              setShowDeleteConfirmation(false);
              setDeleteConfirmText('');
            }}
            className="btn btn-secondary btn-lg flex-1"
            disabled={deleteLoading}
          >
            취소
          </button>
          <button
            onClick={handleDeleteAccount}
            disabled={deleteLoading || deleteConfirmText !== '계정을 삭제합니다'}
            className="btn btn-danger btn-lg flex-1"
          >
            {deleteLoading ? (
              <Loader2 className="w-4 h-4 animate-spin" />
            ) : (
              <UserX className="w-4 h-4" />
            )}
            계정 삭제
          </button>
        </div>

        {/* 닫기 버튼 */}
        <button
          onClick={() => {
            setShowDeleteConfirmation(false);
            setDeleteConfirmText('');
          }}
          className="absolute top-4 right-4 p-2 rounded-lg hover:bg-gray-100 transition-colors"
        >
          <X className="w-5 h-5 text-gray-400" />
        </button>
      </div>
    </div>
  );
};

export default DeleteAccountModal;
